var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (
    _vm.room &&
    _vm.featuresField &&
    _vm.room[_vm.featuresField] &&
    Object.keys(_vm.room[_vm.featuresField]).length > 0
  )?_c('v-row',{staticClass:"object-features",attrs:{"no-gutters":""}},[_c('v-col',{staticClass:"pt-3 pb-1",attrs:{"cols":"12"}},[_c('h3',[_vm._v(_vm._s(_vm.title)+" "+_vm._s(_vm.room.number))])]),_vm._l((Object.keys(_vm.room[_vm.featuresField]).filter(
      function (featureId) {
        return (
          _vm.featuresList[featureId] &&
          _vm.room[_vm.featuresField][featureId].checked === true
        )
      }
    )),function(featureId){return [_c('v-col',{key:featureId + '_quantity',staticClass:"text-right pr-1",attrs:{"cols":"1"}},[(_vm.room[_vm.featuresField][featureId].quantity)?[_vm._v("\n        "+_vm._s(_vm.room[_vm.featuresField][featureId].quantity)+" x\n      ")]:_vm._e()],2),_c('v-col',{key:featureId + '_icon',staticClass:"text-center",attrs:{"cols":"1"}},[_c('v-icon',{attrs:{"small":""}},[_vm._v("\n        "+_vm._s(_vm.featuresList[featureId].icon)+"\n      ")])],1),_c('v-col',{key:featureId + '_name',attrs:{"cols":"10"}},[_vm._v("\n      "+_vm._s(_vm.capitalize(_vm.featuresList[featureId]['name_' + _vm.lang]) +
        (_vm.room[_vm.featuresField][featureId].distance
          ? ': ' + _vm.room[_vm.featuresField][featureId].distance
          : ''))+"\n    ")])]})],2):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }